import * as React from "react";
import * as S from "@styled";
import { connect } from "react-redux";

import { State } from "../model/State";
import Select from "shared/components/select/Select";
import { components, GroupBase } from "react-select";
import { Option } from "../../shared/model/Option";
import { Utilities } from "../../shared/utilities";
import { FilterOptionOption } from "react-select/dist/declarations/src/filters";
import useTaskSelectorClassNameObserver from "processEditor/hooks/UseTaskSelectorClassNameObserver";

const CustomOption = (props: any) => {
    const renderLabel = (labelProps: any) => {
        if (labelProps.data.deprecated != null && labelProps.data.deprecated === true) {
            return <s>{labelProps.data.label}</s>;
        }
        if (labelProps.data.isNotCompatible != null && labelProps.data.isNotCompatible === true) {
            return <s>{labelProps.data.label}</s>;
        }
        return <span>{labelProps.data.label}</span>;
    };
    return (
        <components.Option {...props} className="task-option">
            <div title={props.data.title}>{renderLabel(props)}</div>
        </components.Option>
    );
};

// Filter input as lowercase to disregard case
export const filter = (option: FilterOptionOption<ITypeSelectorModel>, inputValue: string) => {
    const { label, data } = option;
    inputValue = inputValue.toLowerCase();

    const filterableFields = [label.toLowerCase()];
    if (data.metadata) {
        filterableFields.push(data.metadata.toLowerCase());
    }

    return filterableFields.some((f) => f.includes(inputValue));
};

export const TypeSelector: React.FC<ITypeSelectorProps> = (props) => {
    const { controllerRef, menuOpen, setMenuOpen } = useTaskSelectorClassNameObserver();

    const onChange = (selectedValue: Option) => {
        if (props.onChange) {
            props.onChange(selectedValue.value);
        }
    };

    const currentTaskAsOption = Utilities.valueFromId(props.selectorValuesModel, props.selectedTypeId);

    const currentTypeSelector = currentTaskAsOption && props.selectorModel?.find((s) => s?.options?.some((f) => f.value === currentTaskAsOption.value))?.options;
    const currentTypeSelectorAsTitle = currentTypeSelector?.find((f) => f.value === currentTaskAsOption?.value)?.title;

    const hasError = props.className?.includes("has-error");
    const isProductTour = location.search.includes("product_tour_id");

    return (
        <S.FormGroup variant={hasError ? S.FormGroupVariant.error : S.FormGroupVariant.primary} className="task-menu-controller-selector" ref={controllerRef}>
            <div className={props.className as string} title={currentTypeSelectorAsTitle}>
                <Select
                    menuIsOpen={menuOpen}
                    onMenuClose={() => !isProductTour && setMenuOpen(false)} // Blocks closing the menu when clicking outside when product tour is active, still closes the menu when clicking an item
                    onMenuOpen={() => setMenuOpen(true)}
                    classNamePrefix="react-select"
                    className="type-selector"
                    isClearable={false}
                    placeholder={props.placeholder}
                    value={currentTaskAsOption}
                    options={props.selectorModel as GroupBase<Option>[]}
                    isDisabled={props.disabled}
                    filterOption={filter}
                    onChange={onChange}
                    components={{ Option: CustomOption }}
                />
            </div>
        </S.FormGroup>
    );
};

interface ITypeSelectorProps {
    id?: string;
    placeholder?: string;
    selectedTypeId?: string | null;
    selectorModel?: ITypeSelectorModel[];
    selectorValuesModel?: Option[];
    onChange?: (typeId: string) => void;
    className?: string | null;
    searchMetadataProperty?: string;
    disabled?: boolean;
}

export interface ITypeSelectorModel {
    label: string;
    value?: string;
    title?: string;
    options?: ITypeSelectorModel[];
    metadata?: string;
    deprecated?: boolean;
    isNotCompatible?: boolean;
}

const mapTypeSelectorStateToProps = (state: State, ownProps: ITypeSelectorProps): ITypeSelectorProps => {
    let selectedTypeId: string | undefined | null = ownProps.selectedTypeId || state.elements[ownProps.id as string].selectedTypeId;
    let selectorValuesModel = ownProps.selectorValuesModel;

    if (!selectedTypeId) {
        selectedTypeId = null;
    }

    // In some cases <Select> have different structures while passing value and label. If the Select has group there is an options object it has to enter.
    if (ownProps.selectorValuesModel == null) {
        selectorValuesModel = ownProps.selectorModel?.map((x) => ({ value: x.value, label: x.label }));
    }

    return {
        selectedTypeId: selectedTypeId,
        selectorValuesModel: selectorValuesModel,
        disabled: state.uiState.disableEdit || state.uiState.isSaving,
    };
};

export default connect(mapTypeSelectorStateToProps)(TypeSelector);
